var map = {
	"./1200px-Albanian_Naval_Forces.svg.png": 2874,
	"./7088cd512d39daa6d1e4969e2ca0c012.jpg": 5165,
	"./Albanian_Armed_Forces.svg": 3549,
	"./Aleksander Moisiu University Mark.jpg": 7305,
	"./Aleksander Moisiu University.jpg": 7220,
	"./Aleksander Moisiu University1.jpg": 8595,
	"./AuthorPicture1.jpg": 6732,
	"./AuthorPicture10.jpg": 3422,
	"./AuthorPicture2.jpg": 5067,
	"./AuthorPicture3.jpg": 7022,
	"./AuthorPicture4.jpg": 3141,
	"./AuthorPicture5.jpg": 5272,
	"./AuthorPicture6.jpg": 9079,
	"./AuthorPicture7.jpg": 6890,
	"./AuthorPicture8.jpg": 4353,
	"./AuthorPicture9.jpg": 3668,
	"./Disku.mp4": 1447,
	"./Expert in aquaculture and mitiliculture.jpg": 3792,
	"./GettyImages-1406260852-e1677241000978.jpg": 7300,
	"./IMG-20240530-WA0000.jpg": 8007,
	"./IMG-20240530-WA0002.jpg": 2069,
	"./IMG-20240530-WA0003.jpg": 4200,
	"./IMG-20240530-WA0004.jpg": 3995,
	"./IMG-20240530-WA0006.jpg": 6713,
	"./IMG-20240530-WA0007.jpg": 5660,
	"./IMG-20240530-WA0008.jpg": 383,
	"./IMG-20240530-WA0009.jpg": 8674,
	"./IMG-20240530-WA0010.jpg": 7800,
	"./IMG-20240530-WA0011.jpg": 1765,
	"./IMG-20240530-WA0012.jpg": 7562,
	"./IMG-20240530-WA0013 (1).jpg": 4149,
	"./IMG-20240530-WA0013.jpg": 5079,
	"./IMG-20240530-WA0014.jpg": 8764,
	"./IMG-20240530-WA0016.jpg": 4430,
	"./IMG-20240530-WA0017.jpg": 5739,
	"./IMG-20240530-WA0018.jpg": 6608,
	"./Map-of-Albania-and-its-Exclusive-Economic-Zone-EEZ.png": 9105,
	"./Map.png": 422,
	"./PietroCoppo.jpg": 6280,
	"./about.jpg": 6751,
	"./address_image.svg": 3906,
	"./aleksander.png": 6106,
	"./alien-illustration-royalty-free-illustration-1714076146.jpg": 595,
	"./angel.jpg": 1283,
	"./animated_ashutosh.jpg": 7409,
	"./animated_logo.svg": 9083,
	"./aquaculture and mitiliculture.jpg": 9473,
	"./aquaculture.jpg": 7194,
	"./aquaculture1.jpg": 3477,
	"./artifact1.jpg": 1547,
	"./artifact2.jpg": 9564,
	"./artifact3.jpg": 617,
	"./backgorund.jpg": 9916,
	"./background.jpg": 2006,
	"./biomass.jpg": 5910,
	"./biomass.png": 3922,
	"./blogs_image.svg": 7245,
	"./book1.png": 3848,
	"./book2.png": 5955,
	"./book3.png": 746,
	"./book4.png": 7621,
	"./books.jpg": 6526,
	"./books.png": 7594,
	"./bujqesi.jpg": 8861,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./complesteuniversity.jpg": 1486,
	"./complesteuniversity.png": 4074,
	"./contactMail.png": 3189,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./divider.png": 8711,
	"./dsc_logo.png": 8750,
	"./earth.jpg": 1588,
	"./education.svg": 1118,
	"./eez.png": 616,
	"./engin.png": 9617,
	"./engineer.png": 501,
	"./experience.svg": 7480,
	"./explorer of fishing area.png": 5039,
	"./eye.png": 5819,
	"./feelingProud.svg": 8294,
	"./fishing.jpg": 4694,
	"./freecopy_logo.png": 4633,
	"./french.jpeg": 4503,
	"./fullstack.svg": 5137,
	"./future.jpg": 5435,
	"./gcp_logo.png": 1525,
	"./gettyimages-542173470-612x612.jpg": 6884,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./hero.jpeg": 7299,
	"./hidden.jpg": 5810,
	"./hiddenpower.jfif": 5990,
	"./hiddenpower.png": 7667,
	"./highschool.jpg": 938,
	"./hp.png": 7686,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./images (1).jfif": 3219,
	"./images (10).jfif": 5249,
	"./images (2).jfif": 1732,
	"./images (3).jfif": 4465,
	"./images (4).jfif": 9202,
	"./images (5).jfif": 7431,
	"./images (6).jfif": 7224,
	"./images (9).jfif": 6139,
	"./images.jfif": 4549,
	"./images.jpg": 9720,
	"./intel_logo.jpg": 8504,
	"./iu_logo.png": 6056,
	"./jesus-the-creator.jpg": 3435,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./linear-a.jpg": 8247,
	"./mainphoto.png": 6545,
	"./malitomorrit.jpg": 6061,
	"./malitomorrit1.png": 672,
	"./manOnTable.svg": 7473,
	"./mars.webp": 7677,
	"./maturantet.jpg": 9043,
	"./message.jfif": 4104,
	"./message.png": 542,
	"./microsoft_logo.png": 752,
	"./ministriaebujqesise.jpg": 3322,
	"./ministriaemjedisit.jpg": 2662,
	"./mjedisi.jpg": 9287,
	"./moule Bouchot baie de Wissant - Copie.jpg": 9672,
	"./mozilla_logo.png": 6816,
	"./msc-cruises.svg": 1276,
	"./msc.png": 2359,
	"./mscship.jpg": 241,
	"./muffito_logo.png": 9556,
	"./nakospiru.jpeg": 9291,
	"./naval.png": 6476,
	"./naval1.jpg": 7919,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./oldestmaps.jpg": 4482,
	"./peshkimi.jpeg": 4109,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pub1.jpg": 9520,
	"./pub2.jpg": 6783,
	"./pub3.jpg": 8850,
	"./pub4.png": 3977,
	"./pub5.png": 5856,
	"./pubimg/pub1.jpg": 7423,
	"./pubimg/pub2.jpg": 3088,
	"./pubimg/pub3.jpg": 4013,
	"./pubimg/publish.jpg": 6128,
	"./publish.jpg": 2801,
	"./pwa.png": 9180,
	"./redcoral.jpg": 2326,
	"./redcoral.png": 3634,
	"./resources.png": 1267,
	"./resources2.png": 1177,
	"./saayaHealthLogo.png": 4176,
	"./school.jpg": 8526,
	"./school.png": 9594,
	"./seo-certification-course-sm-Recovered.psd": 8134,
	"./shkolla-nako-spiru.jpg": 9628,
	"./shkolla.jpg": 9344,
	"./slideimage0.jpg": 9410,
	"./slideimg/mapofearth.jpg": 2900,
	"./slideimg/oldestmaps1.jpg": 7722,
	"./slideimg/slide.jpg": 7832,
	"./slideimg/slideimage1.jpg": 6020,
	"./slideimg/slideimage2.jpg": 976,
	"./slideimg/slideimage3.jpg": 3830,
	"./slideimg/slideimage4.jpg": 173,
	"./slideimg/slideimage5.jpg": 8432,
	"./slideimg/slideimage6.jpg": 8751,
	"./slideimg/slideimage7.jpg": 2370,
	"./slideimg/slideimage8.jpg": 5081,
	"./stack_of_papers_MHx2ZUT.jpg": 9833,
	"./stanford_logo.png": 6691,
	"./studies.jpg": 3879,
	"./studies1.jpg": 6250,
	"./superintel.png": 7949,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./tekstili.png": 6773,
	"./tiktok_logo.png": 3292,
	"./tomori.jpg": 7738,
	"./ui_ux_design.svg": 9163,
	"./ytlogo.png": 4380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;